import { render, staticRenderFns } from "./DisplayNameSection.vue?vue&type=template&id=5a039493&"
import script from "./DisplayNameSection.vue?vue&type=script&lang=js&"
export * from "./DisplayNameSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports